module.exports = __webpack_public_path__ + "static/img/bar4@2x.acaa5730.png";